<template>
    <div class="row">
        <div class="col-md-12 clearfix">
            <div class="project-list__title">
                Pending Projects
            </div>
            <p class="text-muted mb-2 text-xs max-w-para">
                Displays any pending projects that the current product is included in. To learn more about 
                this feature <a href="https://jasperpim.atlassian.net/wiki/spaces/JPKB/pages/47251457/How+to+use+the+Projects+feature+to+manage+workflows">click here</a>.
            </p>
            <div>
                <div v-if="projects.length > 0" class="projects-list">
                    <div v-for="(project, index) in projects" :key="project.id" class="projects-list__item">
                        <div class="projects-list__item-text">
                            <div class="projects-list__item-name">
                                {{ project.name }}
                            </div>
                            <div>
                                {{ project.desc }}
                            </div>
                        </div>
                        <div class="projects-list__item-actions">
                            <a class="btn btn-primary btn-sm" :href="`/projects/${project.id}/edit`">View</a>
                        </div>
                    </div>
                </div>
                <div v-else class="projects-list">
                    <span>
                        Product has not been added to any projects.
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
const base_url = window.location.protocol + "//" + window.location.host;
export default {
    name: "ProductPendingProjects",
    props: {
        productDetails: Object
    },
    data() {
        return {
            loading: true,
            projects: []
        };
    },
    mounted() {
        axios
            .get(
                `${base_url}/pimapi/products/${
                    this.productDetails.info.id
                }/projects`
            )
            .then(
                function(response) {
                    this.projects = response.data.data;
                }.bind(this)
            )
            .catch(
                function(error) {
                    this.alert.status = "alert-danger";
                    this.alert.message =
                        "Sorry there was an error, please try again later.";
                }.bind(this)
            )
            .finally(
                function() {
                    this.loading = false;
                }.bind(this)
            );
    }
};
</script>

<style lang="scss" scoped>
.project-list__title {
    font-weight: 200;
    font-size: 18px;
    color: #576670;
    margin: 0 0 1rem;
}
.projects-list {
    display: flex;
    flex-direction: column;
}
.projects-list__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin: 0 0 1rem;
    padding: 0.5rem;
    border: 1px solid #dedede;
    border-radius: 3px;
}
.projects-list__item-text {
    display: flex;
    flex-direction: column;
    color: #576670;
}
.projects-list__item-name {
    font-size: 14px;
    font-weight: bold;
}
.projects-list__item-actions {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
